var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWiningTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2675_5101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#F0F9FF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5625 18H27.4375C25.8848 18 24.6191 19.2773 24.6777 20.8242C24.6895 21.1348 24.7012 21.4453 24.7188 21.75H18.5312C17.752 21.75 17.125 22.377 17.125 23.1562C17.125 28.582 19.0879 32.3555 21.7246 34.916C24.3203 37.4414 27.4844 38.7129 29.8164 39.3574C31.1875 39.7383 32.125 40.8809 32.125 42.0293C32.125 43.2539 31.1289 44.25 29.9043 44.25H28.375C27.3379 44.25 26.5 45.0879 26.5 46.125C26.5 47.1621 27.3379 48 28.375 48H39.625C40.6621 48 41.5 47.1621 41.5 46.125C41.5 45.0879 40.6621 44.25 39.625 44.25H38.0957C36.8711 44.25 35.875 43.2539 35.875 42.0293C35.875 40.8809 36.8066 39.7324 38.1836 39.3574C40.5215 38.7129 43.6855 37.4414 46.2812 34.916C48.9121 32.3555 50.875 28.582 50.875 23.1562C50.875 22.377 50.248 21.75 49.4688 21.75H43.2812C43.2988 21.4453 43.3105 21.1406 43.3223 20.8242C43.3809 19.2773 42.1152 18 40.5625 18ZM19.9902 24.5625H24.9355C25.4688 29.8418 26.6465 33.3691 27.9766 35.7305C26.5176 35.0859 25 34.1777 23.6875 32.9004C21.8125 31.0781 20.2891 28.4473 19.9961 24.5625H19.9902ZM44.3184 32.9004C43.0059 34.1777 41.4883 35.0859 40.0293 35.7305C41.3594 33.3691 42.5371 29.8418 43.0703 24.5625H48.0156C47.7168 28.4473 46.1934 31.0781 44.3242 32.9004H44.3184Z",
    fill: "#EAB308"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2675_5101",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2675_5101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2675_5101",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWiningTrophy);
export default __webpack_public_path__ + "static/media/ic_wining_trophy.841e2c4d880ea2567623b97e7b7bf765.svg";
export { ForwardRef as ReactComponent };